import React from 'react';
import tw from 'twin.macro';

interface ImageTextProps {
  image: React.ReactNode;
}

export const overlapImageStyles = tw`lg:(absolute inset-0 object-cover)`;

const ImageText: React.FC<ImageTextProps> = ({ image, children }) => (
  <div tw="my-12 bg-green-400">
    <div tw="container">
      <div tw="relative rounded-lg text-black lg:(my-48 flex justify-between items-center)">
        <div tw="text-xl p-6 pr-12 my-4 lg:(my-6)">{children}</div>
        <div tw="relative overflow-hidden rounded-b-lg lg:(w-auto -my-24 right-6 rounded-lg max-w-md flex-shrink-0)">
          {image}
        </div>
      </div>
    </div>
  </div>
);

export default ImageText;
